var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"align-center"},[_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('p',{staticClass:"text-body-1",class:{ 'required-label': _vm.required }},[_vm._v("\n            "+_vm._s(_vm.label)+"\n        ")])]),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"8"}},[_vm._t("default",null,null,{ label: _vm.label })],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }